import { DATA_API_BASE_URL } from '../config/api';
import type { CountryCode } from '../config/countries';
import { withDraftAvailability } from './draftMocks';
import { getJson } from './http';

/**
 * Which delivery days exist for `country`, one row per table and day (see
 * src/utils/availability.ts for the row shape and the validation). The rows are untrusted: pass
 * them to indexAvailability(). The Express backend on prod answers 404; the availability store
 * turns that into `unavailable`.
 */
export async function fetchAvailability(country: CountryCode, signal?: AbortSignal): Promise<unknown[]> {
  const res = await getJson<{ results?: unknown } | null>(DATA_API_BASE_URL, '/data-availability', {
    query: { country },
    signal,
  });
  const results = res?.results;
  return withDraftAvailability(country, Array.isArray(results) ? results : []);
}
